"use client";
import { useQuery } from "@tanstack/react-query";
import { getCustomerApi } from "@/services";
import { transform } from "utils";
import { useContext } from "react";
import { GlobalContext } from "@/context";
import { useAccount } from "wagmi";
import { message } from "@/components";
const customerApi = getCustomerApi()
export const useSeasonDetail = (props: { seasonId: number }) => {
  const { seasonId } = props;
  const { loggingIn } = useContext(GlobalContext);
  const { address } = useAccount();
  const { data: achievementDetail, isFetching, refetch } = useQuery({
    queryKey: ["ACHIEVEMENT_DETAIL", seasonId, loggingIn, address],
    enabled: !!loggingIn && !!seasonId,
    async queryFn() {
      // 获取token配置
      const { data } = await customerApi.seasons.season(seasonId);
      if (!data?.success) {
        message({
          content:'Oops...Something went wrong. Please try again.',
          className:'message-error'
        })
      }

      return transform(data?.obj || {});
    },
    select(data: any) {
      return data;
    },
    placeholderData: {},
  });

  return {
    achievementDetail,
    isFetching,
    refetch
  }
}